<template>
  <NewComponentLayout>
    <template #title>
      {{ $t('newcomponent.datasets.title') }}
    </template>

    <ComponentDatasetForm />
  </NewComponentLayout>
</template>
<script setup lang="ts">
import NewComponentLayout from '../../layouts/NewComponentLayout.vue';
import ComponentDatasetForm from '../../components/form/ComponentDatasetForm.vue'
</script>